module.exports = __webpack_public_path__ + "img/horizontal_6_1_5010.89231acd.png";